import PropTypes from "prop-types";
import React from "react";
import { withTranslation } from "react-i18next";

import { withTheme } from "@material-ui/core/styles";

import CustomTypography from "../../../../components/Helpers/Typography";
import useMediaQuery from "../../../../hooks/useMediaQuery";

const VehicleDataWidgetActionButton = props => {
  const { t, icon, action, theme, handleClick, isCompact, disabled } = props;

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const style = {
    textAlign: "center",
    cursor: disabled ? "not-allowed" : "pointer",
    color: disabled ? theme.palette.text.secondary : theme.palette.text.primary,
    textTransform: "uppercase",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: isMobile || isCompact ? "row" : "column",
    padding: !isCompact ? 5 : null,
    width: !isCompact ? 154 : null,
    border: isMobile ? `1px solid ${theme.palette.text.blue}` : null,
    borderRadius: 3,
    height: isMobile || isCompact ? null : 60,
    margin: !isCompact ? 3 : null,
  };
  return (
    <div
      style={style}
      role="presentation"
      onClick={disabled ? null : handleClick}
      className="vehicle-data-action-button"
    >
      {icon}
      <CustomTypography
        variant="button"
        color={disabled ? "secondary" : "blue"}
        style={{
          padding: 5,
          fontWeight: 500,
          fontSize: "0.8rem",
        }}
      >
        {action ? t(`Vehicles.Detail.Actions.${action}`) : ""}
      </CustomTypography>
    </div>
  );
};

VehicleDataWidgetActionButton.propTypes = {
  action: PropTypes.string,
  icon: PropTypes.node.isRequired,
  handleClick: PropTypes.func,
  t: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  isCompact: PropTypes.bool,
  disabled: PropTypes.bool,
};

VehicleDataWidgetActionButton.defaultProps = {
  action: null,
  handleClick: null,
  isCompact: false,
  disabled: false,
};

export default withTranslation("common")(withTheme(VehicleDataWidgetActionButton));
export { VehicleDataWidgetActionButton };
